import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import TablePage from "../components/TablePage";

function PaymentMethodsPage() {

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  }

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <TablePage
              {...tablePageParams}
            />
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default PaymentMethodsPage;
